import _styled from "@emotion/styled-base";
export var Layout = _styled("main", {
  target: "ewnbif10"
})({
  name: "ojqyia",
  styles: "position:relative;height:100%;width:100%;"
});
export default Layout;